import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"refresh\">\r\n\r\n<path class=\"st0\" d=\"M2,10c0,4.4,3.6,8,8,8c3.7,0,6.8-2.6,7.7-6h-2.1c-0.8,2.3-3,4-5.6,4c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6\r\n\tc2.6,0,4.8,1.7,5.7,4h-2.2C13.2,8,13,8.2,13,8.5v1c0,0.3,0.2,0.5,0.5,0.5H16h1.5H18h0.5c0.3,0,0.5-0.2,0.5-0.5v-1v-4\r\n\tC19,4.2,18.8,4,18.5,4h-1C17.2,4,17,4.2,17,4.5v1.6C15.6,3.7,13,2,10,2C5.6,2,2,5.6,2,10z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol